module.exports = __webpack_public_path__ + "img/gongye.cce25c9c.png";